/**
 * Comment-related strings.
 */
import React from 'react';
import '../Comment/CommentCard.less';
import ArticleButton from '../ui/ArticleButton/ArticleButton';

export default {
    d_title: 'Conflict Checks',
    h_title: <div>
        <p>Outlaw Practice provides the ability to do continuous conflict checking as new relationships and participants
            are added to your Leads and Cases.</p>
        <p>Learn more about conflict checking in the documentation:</p>
        <p><ArticleButton article='/sections/conflict-checks/' label='Conflict Checks'/></p>
    </div>,

    d_conflict: 'Conflict',
    h_conflict: `<div><p>If this user has a conflict, check this box.</p><p>The owner must then decide whether to use an ethical wall, get a release, or refuse the client's case.</p></div>`,

    d_conflictReport: 'Conflict Report',

    // c_notes is used for the label
    h_notes: `<div><p>If the user has a conflict, they must put the reason for the conflict here.</p></div>`,

    d_runBy: 'Run By',
    h_runBy: 'Which user created and ran the conflict check.',

    d_checkedOn: 'Checked On',
    h_checkedOn: `<div><p>Date the conflict check was run.</p></div>`,

    d_peopleChecked: 'People Checked',
    h_peopleChecked: `<div><p>Which people were checked</p></div>`,

    d_waitingOn: 'Waiting On',
    h_waitingOn: `<div><p>Which users have not responded to the Conflict Check.</p></div>`,

    d_conflicts: 'Conflicts',
    h_conflicts: `<div><p>Which users had conflicts (if any)</p></div>`,

    d_hideReport: 'Hide Report',
    d_showReport: 'Show Report',

    d_ethicalWall: <span style={{wordWrap: 'break-word', whiteSpace: 'break-spaces'}}>Ethical Wall</span>,
    h_ethicalWall: `<div><p>An ethical wall is a way to handle a conflicted user by excluding them from the case.</p><p>The conflicted user will not participate in the case in any way.</p></div>`,

    d_release: 'Release',
    h_release: `<div><p>If a user is conflicted, an alternative to an ethical wall is to have the client sign a release indicating they understand there is a conflict, but that they would like to continue with the firm, and are ok with the conflicted user working on the case.</p></div>`,

    d_signOff: 'Sign Off',
    h_signOff: `<div><p>When a user has reviewed the conflict report and noted any conflicts, they should click this button to indicate that they are finished with the review.</p></div>`,

    d_loadingReport: <i>Loading Report...</i>,
};